import { render } from "./VideoControl.vue?vue&type=template&id=761bda3c"
import script from "./VideoControl.vue?vue&type=script&lang=js"
export * from "./VideoControl.vue?vue&type=script&lang=js"

import "./VideoControl.vue?vue&type=style&index=0&id=761bda3c&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__